<p-menu
  #menu
  id="attach-menu"
  [model]="items"
  [popup]="true"
  appendTo="body"
  styleClass="w-[312px] p-1 rounded-lg"
  (onShow)="onShow()"
  (onHide)="onHide()"
  data-e2e="attach-menu"
>
  <ng-template pTemplate="item" let-item>
    <div class="flex items-start gap-3 px-3 py-2.5" [attr.data-e2e]="'attach-menu-' + item.id">
      <i
        class="text-[20px] leading-5 shrink-0"
        [ngClass]="[item.icon, item.id === 'onedrive' ? 'text-primary' : '']"
        aria-hidden="true"
      ></i>
      <div class="flex flex-col gap-[3px] min-w-0">
        <span class="text-sm leading-[17px] font-bold">{{ item.label }}</span>
        <span class="text-xs leading-[14px] text-muted-color">{{ item.state?.hint }}</span>
      </div>
    </div>
  </ng-template>
</p-menu>
